export default __webpack_public_path__ + "static/media/lady-with-clipboard.455c0163.svg";